//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    back () {
      window.location = 'openpage://0'
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/page500.vue